<template>
  <b-overlay :show="in_progress">
    <div class="row">
      <div class="col-md-3">
        <!-- menu lateral -->
        <div class="form-group">
          <br /><br />
          <label class="text-muted">Filtrar por estado de origen/destino</label>
          <b-form-select v-model="configuracion_buesqueda.filtros.ISO" :options="opciones_estados_republica" size="sm">
          </b-form-select>
        </div>
        <div class="form-group">
          <label class="text-muted">Filtrar solicitudes locales/foráneas</label>
          <b-form-select
            v-model="configuracion_buesqueda.filtros.ambito"
            :options="opciones_ambito_solicitudes"
            size="sm"
          >
          </b-form-select>
        </div>
        <div class="form-group">
          <label class="text-muted">Filtrar por cubicaje [m<sup>3</sup>]</label>
          <b-form-select v-model="configuracion_buesqueda.filtros.m3" :options="opciones_cubicaje" size="sm">
          </b-form-select>
        </div>
        <div class="form-group">
          <label class="text-muted">Ordenar solicitudes</label>
          <b-form-select
            v-model="configuracion_buesqueda.ordenamientos"
            :options="opciones_orden_solicitudes"
            size="sm"
          >
          </b-form-select>
        </div>
        <div class="form-group">
          <label>Categoría</label>
          <b-form-checkbox v-model="configuracion_buesqueda.filtros.preventa" value="1" unchecked-value="0">
            Pre-venta
          </b-form-checkbox>
          <b-form-checkbox v-model="configuracion_buesqueda.filtros.compartida" value="1" unchecked-value="0">
            Mudanza compartida
          </b-form-checkbox>
          <b-form-checkbox v-model="configuracion_buesqueda.filtros.numero_cotizaciones" value="1" unchecked-value="0">
            Sin cotizaciones
          </b-form-checkbox>
        </div>

        <div class="row">
          <div class="col-12 d-block d-sm-none">
            <hr />
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div v-if="solicitudes_filtradas.length == 0" class="row text-center">
          <div class="col-12">
            <div class="jumbotron bg-white">
              <h1 class="display-4" style="font-size: 1.8em">
                No hay solicitudes con el criterio de búsqueda que usaste
              </h1>
              <p class="lead">Prueba con otros filtros de búsqueda</p>
            </div>
          </div>
        </div>
        <div v-else-if="solicitudes.length > 0" class="row">
          <div class="col-12 mb-3">
            <h5 class="text-info">
              {{ solicitudes_filtradas.length }}/
              {{ solicitudes.length }}
              solicitudes para comprar
            </h5>
          </div>
        </div>
        <transition-group name="list-complete" class="row">
          <div v-for="(s, index) in solicitudes_filtradas" :key="s.id_mm" class="col-12 mb-3 list-complete-item">
            <card-solicitud :s="s" :index="index"></card-solicitud>
          </div>
        </transition-group>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import cardSolicitud from 'views/pro/cotizar/card_solicitud_invitado.vue';
import moment from 'moment';

require('moment/locale/es');

Vue.prototype.moment = moment;

export default {
  components: {
    cardSolicitud
  },
  data() {
    return {
      base_url,
      empresa: {
        id: 1278,
        clave: 974073798,
        token: 'BPAJBnteVm4yqKW5QFE9PSWRdo0wX8x0Rrpamljh'
      },
      opciones_cubicaje: [
        { value: [0, 200], text: 'Cualquier cubicaje' },
        { value: [0, 12], text: '0 a 12 m3' },
        { value: [12, 21], text: '12 a 21 m3' },
        { value: [21, 38], text: '21 a 38 m3' },
        { value: [28, 80], text: '38 a 80 m3' },
        { value: [80, 200], text: 'Más de 80 m3' }
      ],
      opciones_ambito_solicitudes: [
        { value: 'todas', text: 'Locales y foráneas' },
        { value: 'Local', text: 'Locales' },
        { value: 'Foranea', text: 'Foráneas' }
      ],
      opciones_orden_solicitudes: [
        { value: { columna: 'fecha_liberacion', orden: 'ASC' }, text: 'Solicitudes más nuevas' },
        { value: { columna: 'fecha_requerida', orden: 'DESC' }, text: 'Fecha más próxima' },
        { value: { columna: 'fecha_requerida', orden: 'ASC' }, text: 'Fecha más lejana' },
        { value: { columna: 'precio_m4', orden: 'DESC' }, text: 'Mayor a menor precio' },
        { value: { columna: 'precio_m4', orden: 'ASC' }, text: 'Menor a mayor precio' }
      ],
      opciones_estados_republica: [],
      in_progress: false,
      solicitudes: [],
      configuracion_buesqueda: {
        filtros: {
          ambito: 'todas',
          m3: [0, 200],
          ISO: null,
          preventa: '0',
          compartida: '0',
          numero_cotizaciones: '0'
        },
        ordenamientos: {
          columna: 'fecha_liberacion',
          orden: 'ASC'
        }
      },
      total_solicitudes: 0
    };
  },
  computed: {
    solicitudes_filtradas() {
      let { solicitudes } = this;
      if (this.configuracion_buesqueda.filtros.ISO != null) {
        solicitudes = this.filtrar_por_estado_republica(solicitudes);
      }
      if (this.configuracion_buesqueda.filtros.ambito != 'todas') {
        solicitudes = this.filtrar_por_ambito(solicitudes);
      }
      if (this.configuracion_buesqueda.filtros.m3[0] != 0 || this.configuracion_buesqueda.filtros.m3[1] != 200) {
        solicitudes = this.filtrar_por_cubicaje(solicitudes);
      }
      if (this.configuracion_buesqueda.filtros.preventa == '1') {
        solicitudes = this.filtrar_por_preventa(solicitudes);
      }
      if (this.configuracion_buesqueda.filtros.compartida == '1') {
        solicitudes = this.filtrar_por_compartida(solicitudes);
      }
      if (this.configuracion_buesqueda.filtros.numero_cotizaciones == '1') {
        solicitudes = this.filtrar_sin_cotizaciones(solicitudes);
      }

      if (solicitudes.length > 0) {
        solicitudes = this.ordenar_solicitudes(solicitudes);
      }

      return solicitudes;
    }
  },
  mounted() {
    this.getSolicictudes();
  },
  methods: {
    getSolicictudes() {
      this.in_progress = true;
      this.$http.post(`${api_url}graphql?token=${this.empresa.token}&id=${this.empresa.id}`, {
        query: `{
          solicitudes_por_comprar(
            where: {
              AND: [
                { column: FECHA_REQUERIDA, operator: GTE, value: "${moment().format('YYYY-MM-DD')}" }
              ]
            }
            clave: ${this.empresa.clave}
            ) {
            id_mm
            ambito
            m3
            fecha_requerida
            dir_origen
            dir_destino
            via_contacto
            numero_cotizaciones
            fecha_liberacion
            precio_m4
            preocupacion_cliente
            direcciones {
              lugar
              estado_republica {
                nombre
              }
            }
            inmueble_origen {
              descripcion
            }
            inmueble_destino {
              descripcion
            }
            descuento_solicitud {
              precio_promocion
            }
            cliente_frecuente {
              correo
            }
          }
        }`
      }, { timeout: 120000 }).then((r) => {
        this.obtener_estados_republica(r.body.data.solicitudes_por_comprar);
        this.solicitudes = r.body.data.solicitudes_por_comprar;
        this.in_progress = false;
      }, () => {
        this.in_progress = false;
        alert('No podemos comunicarnos con el servidor o esta tardando mucho en responder. Inténtelo más tarde');
      });
    },
    obtener_estados_republica(solicitudes) {
      let estados = [];
      const estados_objetos = [
        { text: 'Cualquier estado de la república', value: null }
      ];

      solicitudes.forEach((el) => {
        if (el.direcciones && el.direcciones.length >= 2) {
          if (el.direcciones[0] && el.direcciones[0].estado_republica && !estados.includes(el.direcciones[0].estado_republica.nombre)) {
            estados.push(el.direcciones[0].estado_republica.nombre);
          }
          if (el.direcciones[1] && el.direcciones[1].estado_republica && !estados.includes(el.direcciones[1].estado_republica.nombre)) {
            estados.push(el.direcciones[1].estado_republica.nombre);
          }
        }
      });

      estados = estados.sort();
      estados.forEach((el) => {
        estados_objetos.push({
          text: el,
          value: el
        });
      });

      this.opciones_estados_republica = estados_objetos;
    },
    filtrar_por_estado_republica(solicitudes) {
      const estado = this.configuracion_buesqueda.filtros.ISO;
      return solicitudes.filter((el) => {
        if (el.direcciones && el.direcciones.length >= 2) {
          if (el.direcciones[0] && el.direcciones[0].estado_republica && el.direcciones[0].estado_republica.nombre == estado) {
            return el;
          } if (el.direcciones[1] && el.direcciones[1].estado_republica && el.direcciones[1].estado_republica.nombre == estado) {
            return el;
          }
        }
      });
    },
    filtrar_por_ambito(solicitudes) {
      const { ambito } = this.configuracion_buesqueda.filtros;
      return solicitudes.filter((el) => {
        if (el.ambito == ambito) {
          return el;
        }
      });
    },
    filtrar_por_cubicaje(solicitudes) {
      const { m3 } = this.configuracion_buesqueda.filtros;
      return solicitudes.filter((el) => {
        if (m3[0] < el.m3 && el.m3 <= m3[1]) {
          return el;
        }
      });
    },
    filtrar_por_preventa(solicitudes) {
      return solicitudes.filter((el) => {
        if (el.descuento_solicitud.precio_promocion > 0) {
          return el;
        }
      });
    },
    filtrar_por_compartida(solicitudes) {
      return solicitudes.filter((el) => {
        if (el.via_contacto == 'landing_pages_compartidas') {
          return el;
        }
      });
    },
    filtrar_sin_cotizaciones(solicitudes) {
      return solicitudes.filter((el) => {
        if (el.numero_cotizaciones == 0) {
          return el;
        }
      });
    },
    ordenar_solicitudes(solicitudes) {
      const { columna } = this.configuracion_buesqueda.ordenamientos;
      const { orden } = this.configuracion_buesqueda.ordenamientos;

      if (columna == 'precio_m4' && orden == 'ASC') {
        return solicitudes.sort((a, b) => {
          if (a.precio_m4 < b.precio_m4) {
            return -1;
          }
          if (a.precio_m4 > b.precio_m4) {
            return 1;
          }
          return 0;
        });
      } if (columna == 'precio_m4' && orden == 'DESC') {
        return solicitudes.sort((a, b) => {
          if (a.precio_m4 > b.precio_m4) {
            return -1;
          }
          if (a.precio_m4 < b.precio_m4) {
            return 1;
          }
          return 0;
        });
      } if (columna != 'precio_m4' && orden == 'DESC') {
        return solicitudes.sort((a, b) => {
          if (a[columna] < b[columna]) {
            return -1;
          }
          if (a[columna] > b[columna]) {
            return 1;
          }
          return 0;
        });
      } if (columna != 'precio_m4' && orden == 'ASC') {
        return solicitudes.sort((a, b) => {
          if (a[columna] > b[columna]) {
            return -1;
          }
          if (a[columna] < b[columna]) {
            return 1;
          }
          return 0;
        });
      }
      return solicitudes;
    }
  }
};
</script>

<style lang="css">
.list-complete-item {
  transition: all 0.4s;
  display: inline-block;
}

.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

.list-complete-leave-active {
  position: absolute;
}
</style>
